import { TopTipEdit } from './TopTipEdit';
import { TopTipList } from './TopTipList/TopTipList';
import { TopTipShow } from './TopTipShow';

export const edit = TopTipEdit;
export const list = TopTipList;
export const show = TopTipShow;
